import { z } from 'zod';
import { AbstractControl, FormGroup, type ValidationErrors, type ValidatorFn } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import { AlertControlFacade } from '@medsurf/flat-facades';

export class ZodSharedValidator {
  static validate(schema: z.Schema): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const result = schema.safeParse(control.value);
      if (!result.success) {
        const errors = (result as any).error as z.ZodError;
        Object.keys(errors.formErrors.fieldErrors).forEach((key) => {
          const field = control.get(key);
          if (field) {
            field.setErrors(errors.formErrors.fieldErrors[key] || null);
          }
        });
      }
      return null;
    };
  }

  static handleError(result: FlatModels.ErrorControlModels.MedsurfInputError | any,
                     alertControlFacade: AlertControlFacade,
                     form: FormGroup): void {
    if (result.error) {
      if (result.error.name === 'MedsurfInputError') {
        const errors = result.error.options.fieldErrors;
        Object.keys(errors).forEach((key) => {
          const field = form.get(key);
          if (field) {
            field.markAsDirty();
            field.setErrors(errors[key] || null);
          }
        });
        return;
      }
    } else {
      alertControlFacade.requestAddError(result);
    }
  }

  static handleFileError(result: FlatModels.ErrorControlModels.MedsurfError | any,
                  alertControlFacade: AlertControlFacade): void {
    if (result.error && result.error.name === FlatModels.ErrorControlModels.MedsurfError.name) {
      alertControlFacade.requestAddAlert({
        key: 'main',
        detail: result.error.message,
        severity: FlatModels.AlertControlModels.AlertType.enum.error,
        life: FlatModels.AlertControlModels.AlertTime.DEFAULT
      });
      return;
    }
  }
}